<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrIcDegerTablo from "@/models/StrIcDegerTablo";
import AltTable from "./AltTable.vue";
import StrIcDegerBirimAddEdit from "../StrIcDegerBirim/AddEdit.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
export default {
  mixins: [Api, Sabit, StrIcDegerTablo],
  page: {
    title: "Kurumsal Riskler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    AltTable,
    StrIcDegerBirimAddEdit,
    formcombobox
  },
  data() {
    return {
      title: this.$t("StrIcDegerTablo.Title"),
      items: [
        {
          text: this.$t("StrIcDegerTablo.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrIcDegerTablo.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrIcDegerTablo.Title"),
          active: true,
        },
      ],
      FilitrelemePenceresi: false,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Seviye: "",
      UstId: "",
      Icdegerid: "",
      siralama:"&Asc=SiraNo",
      degerlendirmetur: 1,
      UpdateAltTable: false,
      Degerlendirmeturleri:[
            {"id":"1","value":"Kalite Öz Değerlendirme"},
            {"id":"2","value":"Akran Değerlendirme"},
            {"id":"3","value":"Program Öz Değerlendirme"},
            {"id":"4","value":"İç Değerlendirme"}
  
          ],
      DegerlendirmeturleriCombobox: []
    };
  },
  validations: {
      degerlendirmetur: {},
  },
  methods: {
    Get() { 
      this.DataUpdate = "";
      let Filter = "&Seviye=0";
            if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }
      if(this.degerlendirmetur!=null && this.degerlendirmetur!=""){
        Filter=Filter+ "&Degerlendirmetur=" + this.degerlendirmetur;
      }
      this.ActionsFilterGet({ Service: "StrIcDegerTablo", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.UstId = null;
        this.DataUpdate =  ""
      });
      this.DegerlendirmeturleriCombobox=[];
      for (var n=0 ; n<this.Degerlendirmeturleri.length; n++){

          this.DegerlendirmeturleriCombobox.push ({Id:this.Degerlendirmeturleri[n].id,Value:this.Degerlendirmeturleri[n].value})


      }
    },
    ChangePage(){
      this.Get()
    }

  },
};
</script>
<style>
.table-bordered {
    border: 2px solid #323748;
}
</style>
<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <formcombobox
                :FormDataType="{
                  FieldName: 'Değerlendirme Tür',
                  Field: 'combobox',
                  FieldTitle: 'Değerlendirme Tür',
                  ComboDataArray: DegerlendirmeturleriCombobox,
                }"
                :Value="degerlendirmetur"
                :v="$v.degerlendirmetur"
                @input="(degerlendirmetur = $event),ChangePage()"
              />
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrIcDegerTablo @click="(DataUpdate = StrIcDegerTabloData), (AddEdit = 'Add'), (Seviye = 0)">
                    <i class="mdi mdi-plus me-1"></i>
                    {{ this.$t("StrIcDegerTablo.Page.YeniKayitEkle") }}
                  </button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">
                      {{ $t("StrIcDegerTablo.Table.SiraNo") }}
                       <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    <th scope="col">
                      {{ $t("StrIcDegerTablo.Table.TabloAdi") }}
                       <i style="margin-left:10px" v-if="siralama!='&Asc=TabloAdi'" @click="siralama='&Asc=TabloAdi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=TabloAdi'" @click="siralama='&Desc=TabloAdi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    <th scope="col" >
                      {{ $t("StrIcDegerTablo.Table.Aktif") }}
                    </th>
                    <th scope="col"  >
                      {{ $t("StrIcDegerTablo.Table.Islem") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
                  <tr>
                    <th scope="row" class="custom-accordion">
                      <a
                        class="
                          text-body
                          fw-medium
                          py-1
                          d-flex
                          align-items-center
                        "
                        data-toggle="collapse"
                        v-b-toggle="'CollapseAltTablo' + TableDataVerileri.Id"
                        role="button"
                        aria-expanded="false"
                        aria-controls="categories-collapse"
                      >
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
                    <td>{{ TableDataVerileri.Sirano }}</td>
                    <td>{{ TableDataVerileri.Tabloadi }}</td>
                    <td >
                      <i v-if="TableDataVerileri.Aktif" class="fas fas fa-check"></i>
                      <i v-if="!TableDataVerileri.Aktif" class="fas fas fa-times"></i>
                    </td>
                    <td >
                      <b-button-group>
                        <b-button variant="success" v-b-modal.StrIcDegerTablo @click="(Seviye = 1), (DataUpdate = StrIcDegerTabloData), (AddEdit = 'Add'), (UstId = TableDataVerileri.Id)"><i class="fa fa-plus"></i></b-button>
                        <b-button variant="primary" v-b-modal.StrIcDegerTablo @click="(Seviye = 0), (DataUpdate = TableDataVerileri), (AddEdit = 'Edit')"><i class="fa fa-pencil-alt"></i></b-button>
                        <b-button variant="danger" @click="Delete('StrIcDegerTablo', TableDataVerileri.Id)"><i class="fa fa-trash-alt"></i></b-button>
                      </b-button-group>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <b-collapse class="collapse show p-3" :id="'CollapseAltTablo' + TableDataVerileri.Id" >
                        <AltTable :UstId="TableDataVerileri.Id" @AddEdit="AddEdit = $event" @UpdateAltTable="UpdateAltTable = false" :UpdateAltTable="UpdateAltTable" @Seviye="Seviye = $event" @DataUpdate="DataUpdate = $event" @UstId="UstId = $event" @Icdegerid="Icdegerid = $event" />
                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
 
      <AddEdit :DegerlendirmeTur="degerlendirmetur" :Id="DataUpdate" :AddEdit="AddEdit" :Seviye="Seviye" :UstId="UstId" @TableUpdate="Get(), UpdateAltTable = true" />
      <StrIcDegerBirimAddEdit :Icdegerid="Icdegerid" @Update="Get()" :DegerlendirmeTur="degerlendirmetur" />
    </Layout>
  </Loader>
</template>
